import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectProductId = (store: StoreSchema) => store.product.productData.productId
